import React from 'react';
import './NotificationModal.css';

interface NotificationModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  message: string;
  icon?: string;
  type?: 'success' | 'error' | 'warning' | 'info';
}

const NotificationModal: React.FC<NotificationModalProps> = ({
  isOpen,
  onClose,
  title,
  message,
  icon = "/images/icons/settings.svg",
  type = "info"
}) => {
  const handleOverlayClick = (e: React.MouseEvent) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  if (!isOpen) return null;

  // Get default icon based on type if no custom icon provided
  const getDefaultIcon = () => {
    if (icon !== "/images/icons/settings.svg") return icon; // Use custom icon if provided
    
    switch (type) {
      case 'success': return "/images/icons/settings.svg";
      case 'error': return "/images/icons/settings.svg";
      case 'warning': return "/images/icons/settings.svg";
      default: return "/images/icons/settings.svg";
    }
  };

  return (
    <div className="notification-modal-overlay" onClick={handleOverlayClick}>
      <div className="notification-modal-container" onClick={(e) => e.stopPropagation()}>
        <button className="notification-modal-close" onClick={onClose}>
          ×
        </button>
        
        <div className="notification-modal-content">
          <div className={`notification-modal-icon notification-modal-icon--${type}`}>
            <img src={getDefaultIcon()} alt="Notification" />
          </div>
          
          <h3 className="notification-modal-title">{title}</h3>
          
          <p className="notification-modal-message">{message}</p>
          
          <button className={`notification-modal-button notification-modal-button--${type}`} onClick={onClose}>
            Đã hiểu
          </button>
        </div>
      </div>
    </div>
  );
};

export default NotificationModal;
